import RequiredFieldPossibleValue from "./RequiredFieldPossibleValue";

export default class RequiredField {

    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.fieldName = jsonResponse["field-name"];
        this.displayName = jsonResponse["display-name"];
        this.description = jsonResponse["description"];
        this.dataType = jsonResponse["data-type"];
        this.mandatory = jsonResponse["mandatory"];
        this.possibleValues = [];

        let jsonPossibleValues = jsonResponse["possible-values"];

        if (jsonPossibleValues !== undefined && jsonPossibleValues !== null) {
            jsonPossibleValues.forEach(possibleValue => {
                this.possibleValues.push(new RequiredFieldPossibleValue(possibleValue));
            });
        }
    }

    static toJson = function (obj) {
        let jsonObj = {};
        jsonObj["id"] = obj.id;
        jsonObj["field-name"] = obj.fieldName;
        jsonObj["display-name"] = obj.displayName;
        jsonObj["description"] = obj.description;
        jsonObj["data-type"] = obj.dataType;
        jsonObj["mandatory"] = obj.mandatory;
        return jsonObj;
    };
}